import * as React from 'react';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PersonIcon from '@mui/icons-material/Person';
import AddIcon from '@mui/icons-material/Add';
import StraightenOutlinedIcon from '@mui/icons-material/StraightenOutlined';
import Typography from '@mui/material/Typography';
import { blue } from '@mui/material/colors';
import { connect } from 'react-redux'
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import {PaperComponent} from '../../../utils/Common'

const emails = ['username@gmail.com', 'user02@gmail.com'];

function Index(props) {
  const { onClose,  open } = props;
  var mainLayers = props.main.mainLayers;
  const [code, setCode] = useState('');

  useEffect(() => {
    var target = props.main.menuControl.target;
    if(target && target.get('inviteCode')){
      setCode(target.get('inviteCode'))
    }
    else{      
      setCode('')
    }
  }, [open])
  
  const onChange = (e)=>{
    setCode(e.target.value)
  }

  const onOk = (e)=>{
    if(code)
      props.onOk(code)
  }
  return (
    <Dialog
      PaperComponent={PaperComponent}
      PaperProps={{drag_id:'invite-dialog-title'}}
      aria-labelledby="invite-dialog-title" 
      open={open}>
      <DialogTitle id='invite-dialog-title' style={{display:'flex', alignItems:'center'}}><PersonAddAltIcon style={{marginRight: 10}}/>Invite code</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {/* To subscribe to this website, please enter your email address here. We
          will send updates occasionally. */}
        </DialogContentText>
        <TextField
          name="code"
          margin="dense"
          label="Code"
          type="text"
          fullWidth
          variant="standard"
          onChange={onChange}
          value={code}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onOk}>Ok</Button>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
const mapStateToProps = (state) => {
    return {
      main: state.main,
    };
  };
  
  const mapDispatchProps = (dispatch) => {
    return {   
    };
  };
  
export default connect(mapStateToProps, mapDispatchProps)(Index);